export const BOOKMARKS = 'BOOKMARKS';
export const BOOKMARKS_REQUEST = 'BOOKMARKS_REQUEST';
export const BOOKMARKS_SUCCESS = 'BOOKMARKS_SUCCESS';
export const BOOKMARKS_FAILURE = 'BOOKMARKS_FAILURE';
export const BOOKMARKS_MODAL_OPENED = 'BOOKMARKS_MODAL_OPENED';
export const BOOKMARKS_MODAL_CLOSED = 'BOOKMARKS_MODAL_CLOSED';
export const BOOKMARKS_FORM_SUBMITTED = 'BOOKMARKS_FORM_SUBMITTED';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/Bookmarks/BookmarksConstants.js